import type { MarkerSelectionState, MapAccessibilityTexts } from "../map/types";
import { getMarkerAccessibilityLabel } from "../../utils/label";
export interface Input {
  amount: number;
  animationDelay: number;
  selectionState: MarkerSelectionState;
  mapAccessibilityTexts?: MapAccessibilityTexts;
}
$ const accessibilityLabel = getMarkerAccessibilityLabel({
  mapAccessibilityTexts: input.mapAccessibilityTexts,
  contentKey: "clusterListings",
  itemsTotal: input.amount,
});

<div class=["map-cluster", input.selectionState] style={ "animation-delay": ` ${input.animationDelay}s;` } aria-label=accessibilityLabel>
  <span>${input.amount}</span>
</div>
